// extracted by mini-css-extract-plugin
export default {"root":"TabItem_root__RaUTA","active":"TabItem_active__hEY0e","placeHolderShimmer":"TabItem_placeHolderShimmer__Gv-B9"};